import moment from "moment";
import { getApiInstance } from "../../AppService";
import {
  CURRENT_DATE,
  FROM_DATE,
  ORDER_SALES_REPORT_DOWNLOAD,
  OREDR_REPORT_BY_BUSINESS_AND_DURATION,
  SEARCH_ORDERS_REPORT_BY_FILTER,
  TOP_SELLING_PRODUCTS,
} from "../../constant";
import { getMainProductsWithVariantsAPI } from "../BusinessPreview/BusinessPreviewAPI";

export const searchOrdersReportsByFiltersApi = async (data) => {
  try {
    const instance = getApiInstance({
      header: {
        businessId: data?.businessId,
      },
    });

    const response = await instance.get(SEARCH_ORDERS_REPORT_BY_FILTER, {
      params: {
        from: data?.from
          ? moment(data?.from).startOf("day").valueOf()
          : FROM_DATE,
        // from: data?.from || moment().subtract(100, "days").valueOf(),
        to: data?.to ? moment(data?.to).endOf("day").valueOf() : CURRENT_DATE,
        pageNo: data?.pageNo || 1,
        pageSize: data?.pageSize || 100,
        status: data?.status || "",
        orderId: data?.orderId,
        ondcOrderId: data?.ondcOrderId,
        deliveryType: data?.deliveryType,
        ondcCart: data?.ondcCart,
        ondcBapId: data?.ondcBapId,
        deliveredFrom: data?.deliveredFrom
          ? moment(data?.deliveredFrom).startOf("day").valueOf()
          : "",
        deliveredTo: data?.deliveredTo
          ? moment(data?.deliveredTo).endOf("day").valueOf()
          : "",
      },
    });

    console.log("searchOrdersReportsByFiltersApi:", response.data);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getTopSellingProducts = async ({ businessId, params }) => {
  try {
    const instance = getApiInstance({
      header: {
        businessId,
      },
    });

    const response = await instance.get(TOP_SELLING_PRODUCTS, { params });

    const allProduts = await getMainProductsWithVariantsAPI(businessId);

    console.log(
      "TOP_SELLING_PRODUCTS:",
      response.data,
      allProduts,
      mergeProductArrayData(response.data?.details, allProduts?.details)
    );

    if (response?.data?.details?.length > 0) {
      return mergeProductArrayData(response.data?.details, allProduts?.details);
    }

    return [];
  } catch (error) {
    console.log(error);
  }
};

const mergeProductArrayData = (arr1, arr2) => {
  const dataMap = arr2?.reduce((acc, item) => {
    acc[item?.id] = item;
    return acc;
  }, {});

  return arr1.map((item) => ({
    ...item,
    productInfo: dataMap[item.productId] || {},
  }));
};

export const downloadOrderSaleReportsApi = async (data) => {
  try {
    const instance = getApiInstance({
      header: {
        businessId: data?.businessId,
      },
    });

    const response = await instance.get(ORDER_SALES_REPORT_DOWNLOAD, {
      params: {
        orderStatus:
          data?.orderStatus ||
          "ordercreated,orderready,orderapproved,ordershipped,orderdelivered,bordercanceled,lordercanceled,cordercanceled",
        from: data?.fromDate,
        to: data?.toDate,
        businessIds: data?.businessId,
      },
    });

    console.log("ORDER_SALES_REPORT_DOWNLOAD:", response.data);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

// export const getOrderReportByBusinessAndDurationAPI = async (businessId) => {
//   try {
//     const instance = getApiInstance({
//       header: {
//         businessId,
//       },
//     });

//     const response = await instance.get(OREDR_REPORT_BY_BUSINESS_AND_DURATION, {
//       params: {
//         orderStatus: 'ordercreated,ordercreated,orderready,orderapproved,ordershipped,orderdelivered,bordercancelled,bordercanceled,cordercanceled',
//         fromDate:"2022-01-01",
//         toDate: moment().format('YYYY-MM-DD')
//       }
//     });

//     console.log("getOrderReportByBusinessAndDurationAPI:", response.data);
//     return response.data;
//   } catch (error) {
//     console.log(error);
//   }
// };

export const getOrderReportByBusinessAndDurationAPI = async (businessIds) => {
  try {
    const instance = getApiInstance();

    const response = await instance.post(
      OREDR_REPORT_BY_BUSINESS_AND_DURATION,
      {
        params: {
          orderStatus: "ordercreated,orderdelivered",
          fromDate: "2022-10-31",
          toDate: moment().format("YYYY-MM-DD"),
          // toDate: '2024-10-31',
        },
        data: businessIds,
      }
    );

    console.log("getOrderReportByBusinessAndDurationAPI:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching order report:", error);
    throw error;
  }
};
